export const AdditionalBookings =
  "additionalBookings {\n" +
  " waitingPremiseIds\n" +
  " typeWiseWaitingList\n" +
  " bookingId\n" +
  " bookingRequestType\n" +
  " requestStatus\n" +
  " endTime\n" +
  " extras {\n" +
  " login\n" +
  " logout\n" +
  " registrationNumber\n" +
  " entityTypeId\n" +
  " vehicleId\n" +
  " eventReason\n" +
  " loginShiftId\n" +
  " logoutShiftId\n" +
  " overallRating\n" +
  " mealData\n" +
  " premiseId\n" +
  " premiseName\n" +
  " premiseEndTime\n" +
  " premiseStartTime\n" +
  " }\n" +
  " loginShiftId\n" +
  " logoutShiftId\n" +
  " bookingRequestId\n" +
  " signInTime\n" +
  " startTime\n" +
  " tokenId\n" +
  " premiseId\n" +
  " tokenName\n" +
  " premiseName\n" +
  " premiseType\n" +
  " }\n";

export const USER_REQUEST_DTOS =
  " userRequestDTOS{\n" +
  " userRequestId\n" +
  " userId\n" +
  " scheduleId\n" +
  " direction\n" +
  " status\n" +
  " tripdetail{\n" +
  " tripTime\n" +
  " bulkScheduleEndDate\n" +
  " requestType\n" +
  " pickupLocation{\n" +
  " id\n" +
  " latitude\n" +
  " longitude\n" +
  " address\n" +
  " landmark\n" +
  " }\n" +
  " dropLocation {\n" +
  " id\n" +
  " latitude\n" +
  " longitude\n" +
  " address\n" +
  " landmark\n" +
  " }\n" +
  " rideOtp\n" +
  " nextDayLogout\n" +
  " shuttle\n" +
  " }\n" +
  " scheduleType\n" +
  " markedAsLeave\n" +
  " adhocBookingReason\n" +
  " reasonForLeave\n" +
  " editCutoff\n" +
  " cancelCutoff\n" +
  " adHocCutoff\n" +
  " noShowCutoff\n" +
  " bookingId\n" +
  " }\n";

export const HOME_ADDRESS_INFO =
  "homeAddressInfo{\n" + " nativeId\n" + " guid\n" + " address\n" + " geoCord\n" + " landmark\n" + " type\n" + " locType\n" + "}\n";

export const BOOKING_DETAIL_DTOS =
  "bookingDetailDTOS {\n" +
  " bookingId\n" +
  " recurrenceId\n" +
  " meetingId\n" +
  " bookingRequestType\n" +
  " bookingReason\n" +
  " approvalType\n" +
  " autoApprovalTime\n" +
  " premiseType\n" +
  " requestStatus\n" +
  " signOutTime\n" +
  // " bookingType\n" +
  " endTime\n" +
  " extras {\n" +
  " login\n" +
  " logout\n" +
  " projectCode\n" +
  " eventReason\n" +
  " loginShiftId\n" +
  " logoutShiftId\n" +
  "    subject\n" +
  " dynamicData\n" +
  " }\n" +
  "loginShiftId\n" +
  " logoutShiftId\n" +
  " bookingRequestId\n" +
  " signInTime\n" +
  " startTime\n" +
  " channel\n" +
  " officeId\n" +
  AdditionalBookings +
  " tokenId\n" +
  " premiseId\n" +
  " tokenName\n" +
  " premiseName\n" +
  " timezone\n" +
  USER_REQUEST_DTOS +
  " specialRequests\n" +
  " }\n";

export const EMP_DETAIL_QUERY = [
  "{\n" +
    "name\n" +
    "empId\n" +
    "empGuid\n" +
    "email\n" +
    "gender\n" +
    "officeGuid\n" +
    "officeLocation\n" +
    "officeTimeZoneId\n" +
    "projectId\n" +
    "empWeeklyOff\n" +
    BOOKING_DETAIL_DTOS +
    HOME_ADDRESS_INFO,
  "}\n" + "}"
];

export const EMP_INFO =
  "name\n" +
  "empId\n" +
  "email\n" +
  "empGuid\n" +
  "gender\n" +
  "officeGuid\n" +
  "officeLocation\n" +
  "officeTimeZoneId\n" +
  "projectId\n" +
  "preferredLocale\n" +
  "transportUser\n" +
  "empWeeklyOff\n ";
